<template>
    <div class="cont">
        <div class="gup" v-for="(item, key) in classList" :key="key">
            <div class="til">{{getFormatDate(item.Date)}}</div>
            <div class="list">
                <div class="item" :class="{'bn':!compareNowForDateStr(item.Date)}" v-for="word in item.VocabularyModel" :key="word.Id" @click="compareNowForDateStr(item.Date)?'':selWord(word)">{{word.Text}}
                    <span class="select" v-if="word.HasStudied"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getFormatDate, compareNowForDateStr } from '@/plugin/tools'
import mainDelegate from '@/delegate/mainDelegate'
export default {
    name: 'MyClassList',
    mixins: [mainDelegate],
    methods: {
        selWord(word) {
            this.word = word
        },
        compareNowForDateStr(dataStr) {
            return compareNowForDateStr(dataStr)
        },
        getFormatDate(date) {
            return getFormatDate(date)
        }
    }
}
</script>

<style lang="less" scoped>
@import 'val.less';
@border-color: #bbb;
.cont {
    text-align: left;
    .gup {
        background: #fafafa;
        border: solid 1px @border-color;
        border-radius: 5px;
        margin: 16px;
        .til {
            display: flex;
            text-align: center;
            font-size: 14px;
            color: @main-color;
            line-height: 24px;
            margin: 16px 16px 0px 16px;
            font-size: 14px;
            font-weight: 500;
            &:before {
                content: '';
                display: inline-block;
                width: 24px;
                height: 24px;
                background: url('../assets/img/calendar.png');
                margin-right: 10px;
            }
        }
        .list {
            .item {
                padding: 9px 16px 10px 16px;
                line-height: 28px;
                font-size: 20px;
                color: @greyishBrown;
                border-bottom: solid 1px @border-color;
                .select {
                    float: right;
                    width: 17px;
                    height: 28px;
                    background: url(../assets/img/select.png);
                    background-repeat: no-repeat;
                    background-position: right;
                }
            }
        }
    }
}
@media only screen and (min-width: @rwd) {
    .cont {
        max-width: 480px;
        margin: 0px auto;
        .gup {
            .list {
                .item {
                    &:hover {
                        background: @white;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/MyClassList.vue